import { FullWidthPage } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useCustomerAppConfig } from "undercarriage";

import { getFundingApplicationStagesQueryOptions } from "../../queries/funding-application-configuration/queries";

import { AddAnotherPlatformNext } from "./add-another-platform-next";
import { MESSAGES } from "./message-definitions";

export const AddAnotherPage = () => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { data: fundingApplicationStages } = useSuspenseQuery(getFundingApplicationStagesQueryOptions(customerDomain));

  return (
    <FullWidthPage
      constrainWidth
      title={intl.formatMessage(MESSAGES.addAnotherPlatformHeading)}
      subtitle={intl.formatMessage(MESSAGES.selectAditionalPlatformDescription)}
    >
      <AddAnotherPlatformNext fundingApplicationStages={fundingApplicationStages} />
    </FullWidthPage>
  );
};
